import { useQuery } from "@apollo/client/react";
import COMPANION_SUBSCRIPTION_QUERY from "@graphql/queries/CompanionSubscription";
import { CompanionSubscriptionStatus } from "@src/codegen/gql-schema";

export type CompanionSubscription = {
  planKey: string;
  status: CompanionSubscriptionStatus;
  monthlyTreats: number;
  activeUntil: string | null;
};

export function useCompanionSubscription() {
  const { data, loading, error, refetch } = useQuery(
    COMPANION_SUBSCRIPTION_QUERY,
    { fetchPolicy: "cache-and-network" },
  );

  const raw = data?.user?.companionSubscription ?? null;
  const subscription: CompanionSubscription | null = raw
    ? {
        planKey: raw.planKey,
        status: raw.status,
        monthlyTreats: raw.monthlyTreats,
        activeUntil:
          typeof raw.activeUntil === "string"
            ? raw.activeUntil
            : null,
      }
    : null;

  const isCanceledButActive =
    subscription?.status === CompanionSubscriptionStatus.Canceled &&
    subscription.activeUntil !== null;
  const isActive =
    subscription?.status === CompanionSubscriptionStatus.Active ||
    isCanceledButActive;
  const isTeamsCustomer =
    data?.user?.account?.isTeamsCustomer === true;

  return {
    subscription,
    isActive,
    isCanceledButActive,
    isTeamsCustomer,
    loading,
    error,
    refetch,
  };
}
